
export default {
    render(h) {
        return h('div', { class: ['loverly-text'] }, [this.$slots.default])
    },
}
